
import { isNullOrEmpty, isNullOrWhiteSpace, join, printf, toText } from "../../fable_modules/fable-library-js.5.3.0/String.js";
import { FSharpRef, Union } from "../../fable_modules/fable-library-js.5.3.0/Types.js";
import { union_type, int32_type, class_type } from "../../fable_modules/fable-library-js.5.3.0/Reflection.js";
import { addHours, addMinutes, equals as equals_1, op_Subtraction, addYears, toString, addDays, date, compare } from "../../fable_modules/fable-library-js.5.3.0/Date.js";
import { HtmlHelper_createElement } from "../../fable_modules/Feliz.3.3.3/Html.fs.js";
import { display_block, display_hidden, animation_animatePulse, backgroundColor_bgNeutral200, display_inlineFlex, margin_mt6, padding_py2, height_h6, width_w6, cursor_cursorPointer, padding_py3, zIndex_z10, boxShadow_shadowLg, width_wFull, position_absolute, position_relative, margin_mt1, margin_ml1, margin_mt4, justifyContent_justifyBetween, fontWeight_fontSemibold, fontSize_textLg, padding_p6, boxShadow_shadow, borderRadius_roundedLg, flexDirection_flexCol, margin_mb8, fontWeight_fontBold, fontSize_text3Xl, margin_mb2, alignItems_itemsCenter, padding_py8, padding_px8, padding_px6, padding_px4, margin_mxAuto, maxWidth_w7Xl, backgroundColor_bgNeutral50, fontWeight_fontMedium, padding_py1, padding_px3, margin_mt2, gap_gap$002D2, display_flex, fontSize_textSm, margin_mb4, borderRadius_roundedMd, padding_p4, border_border, tw } from "../../fable_modules/Feliz.Tailwind.4.0.2/Strings.fs.js";
import { textColor_textSecondary800, textColor_textSecondary600, md, textColor_textPrimary700, textColor_textPrimary600, textColor_textSuccess800, backgroundColor_bgSuccess50, borderRadius_roundedFull, borderColor_borderNeutral200, textColor_textNeutral500, textColor_textDanger600, space_spaceY6, backgroundColor_bgSurface, space_spaceY4, gap_gap4, textColor_textNeutral600, textColor_textNeutral900, gap_gap3, lg, sm, textColor_textDanger800, borderColor_borderDanger500, backgroundColor_bgDanger50, borderColor_borderNeutral300, backgroundColor_bgSurfaceElevated, textColor_textNeutral700, backgroundColor_bgInfo100, hover, textColor_textInfo700, borderColor_borderInfo500, backgroundColor_bgInfo50 } from "../TailwindExtensions.js";
import { length, append as append_1, empty, map, contains, singleton, ofArray } from "../../fable_modules/fable-library-js.5.3.0/List.js";
import { defaultOf } from "../../fable_modules/fable-library-js.5.3.0/Util.js";
import { createElement, useEffect, useState } from "react";
import React from "react";
import { unwrap, map as map_1, defaultArg } from "../../fable_modules/fable-library-js.5.3.0/Option.js";
import { view as view_4, tiles } from "./ActivityTileSelector.js";
import { stringHash } from "../../fable_modules/fable-library-js.5.3.0/Util.js";
import { view as view_5, isCustomUnit } from "./UnitSelector.js";
import { toUniversalTime } from "../../fable_modules/fable-library-js.5.3.0/DateOffset.js";
import { days } from "../../fable_modules/fable-library-js.5.3.0/TimeSpan.js";
import { TimeOfDayModule_hour, TimeOfDayModule_minute, TimeOfDayModule_parseFormatted, PositiveAmountModule_create, TimeOfDayModule_toStringFormatted } from "../BaseTypes.js";
import { applyOffset, computeOffset } from "./TimeHelpers.js";
import { validateStartDate, validateTitle } from "./FormUtils.js";
import { ChallengeDurationModule_maxDays, ChallengeDurationModule_minDays, ChallengeDurationModule_create, MinAllowedGoal_validate } from "../Challenge.js";
import { labelClass, inputClass, formField, fieldStatusIndicator, autoSaveDelayMs, executeSave, useAutoSave } from "./AutoSave.js";
import { ChangeCharityRequest, ChangeReminderTimeRequest, RescheduleChallengeRequest, ChangeDurationRequest, ChangeTargetAmountRequest, ChangeUnitRequest, ChangeThemeRequest, UpdateDescriptionRequest, RenameChallengeRequest } from "../Shared.js";
import { tryParse, fromParts, equals, toString as toString_1 } from "../../fable_modules/fable-library-js.5.3.0/Decimal.js";
import Decimal from "../../fable_modules/fable-library-js.5.3.0/Decimal.js";
import { singleton as singleton_1 } from "../../fable_modules/fable-library-js.5.3.0/AsyncBuilder.js";
import { Result_Map, FSharpResult$2 } from "../../fable_modules/fable-library-js.5.3.0/Result.js";
import { ApiErrorModule_isNotFound, ApiErrorModule_ofString } from "../ValidationErrors.js";
import { startImmediate } from "../../fable_modules/fable-library-js.5.3.0/Async.js";
import { everyOrgApiKey, searchEveryOrg } from "./CreateChallengeView.js";
import { progressPct, CompletenessChecklist_derive } from "./HeroHelpers.js";
import { view as view_1, Inputs } from "./Hero/ChallengeHero.js";
import { view as view_3, Mode, LockedProps } from "./Hero/ChallengeDetailsSidebar.js";
import { fromString } from "./StatusBadge.js";
import { singleton as singleton_2, append, delay, toList } from "../../fable_modules/fable-library-js.5.3.0/Seq.js";
import { CoverImageSlot } from "./CoverImageSlot.js";
import { view as view_2, skeleton } from "./FeeShareCard.js";
import { derive } from "./FeeShareHelpers.js";
import { DailyLogSection } from "./DailyLogView.js";
import { defaultUnitForActivity } from "./UnitConfig.js";
import { Props, SelectedRange, render } from "./DateRangeCalendar.js";
import { PageErrorKind, PageError_render_Z70A9CE70, skeletonLine, skeletonHeading, inlineError } from "../Layout/Interactions.js";
import { IconWeight, IconSize, IconName, icon } from "../Icons.js";
import { ClientTypes_Msg, ClientTypes_Route } from "../ClientTypes.js";
import { view as view_6 } from "./AbandonDialog.js";

function formatCurrency(amount) {
    return toText(printf("$%.2f"))(amount);
}

/**
 * Format the pledge stats text line (e.g. "12 pledgers · $1250.00 pledged")
 */
export function pledgeStatsText(pledgeCount, totalPledged) {
    const noun = (pledgeCount === 1) ? "pledger" : "pledgers";
    const arg_2 = formatCurrency(totalPledged);
    return toText(printf("%d %s · %s pledged"))(pledgeCount)(noun)(arg_2);
}

/**
 * Whether the pledge stats should render as a clickable link (count > 0)
 */
export function pledgeStatsIsClickable(pledgeCount) {
    return pledgeCount > 0;
}

/**
 * Pure state-transition helper: returns the new (startDate, endDate option) state given a
 * calendar onChange event for the edit-draft form.
 * - Both bounds picked: take the new range as-is.
 * - Only start picked: update start, clear end (range still partial).
 * - Range cleared (None, _): preserve the current start (it remains the saved value), drop the end.
 */
export function applyEditRangeChange(range, currentStart, _currentEnd) {
    const matchValue = range.Start;
    const matchValue_1 = range.End;
    if (matchValue == null) {
        return [currentStart, undefined];
    }
    else if (matchValue_1 == null) {
        const s_1 = matchValue;
        return [s_1, undefined];
    }
    else {
        const e = matchValue_1;
        const s = matchValue;
        return [s, e];
    }
}

/**
 * Outcome of a stale-draft auto-shift decision on edit-draft load.
 * - NoShiftNeeded: saved start is today or future; nothing to do.
 * - InfoShifted (newStart, newEnd, originalStart, duration): saved start was in the past and
 * shifting forward by (today + 1, +duration) fits within the [today, today+1yr] window.
 * Render the info banner and pre-select the shifted range.
 * - DangerShiftImpossible originalStart: saved start was in the past but the shifted range
 * would push the end past today + 1yr. Clear the range and render the danger banner.
 * Currently unreachable while ChallengeDuration.maxDays <= 365.
 */
export class StaleShiftResult extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["NoShiftNeeded", "InfoShifted", "DangerShiftImpossible"];
    }
}

export function StaleShiftResult_$reflection() {
    return union_type("Shared.ChallengeEditView.StaleShiftResult", [], StaleShiftResult, () => [[], [["newStart", class_type("System.DateTime")], ["newEnd", class_type("System.DateTime")], ["originalStart", class_type("System.DateTime")], ["duration", int32_type]], [["originalStart", class_type("System.DateTime")]]]);
}

/**
 * Pure helper — decide whether (and how) to auto-shift a draft's saved range forward
 * when the saved start has fallen into the past. The caller passes "today" from
 * IClock.system so this remains a pure function (no DateTime.Today / DateTime.Now inside).
 */
export function applyStaleShift(canEditSchedule, today, maxDate, savedStart, savedDuration) {
    if (!canEditSchedule) {
        return new StaleShiftResult(0, []);
    }
    else if (compare(date(savedStart), date(today)) >= 0) {
        return new StaleShiftResult(0, []);
    }
    else {
        const newStart = addDays(date(today), 1);
        const newEnd = addDays(newStart, savedDuration);
        if (compare(newEnd, date(maxDate)) <= 0) {
            return new StaleShiftResult(1, [newStart, newEnd, savedStart, savedDuration]);
        }
        else {
            return new StaleShiftResult(2, [savedStart]);
        }
    }
}

function formatBannerDate(d) {
    return toString(d, "MMM d");
}

/**
 * Pure render function for the stale-draft auto-shift banner. The same call shape works
 * from Fable (returns Fable.React.ReactElement) and from SSR (returns Feliz.ViewEngine.ReactElement).
 * Returns Html.none / empty render when no banner should display.
 */
export function renderStaleShiftBanner(shift, dismissed, onDismiss, onPickDifferent) {
    let arg, arg_1, arg_2, value_30;
    let matchResult, duration, newEnd, newStart, originalStart;
    switch (shift.tag) {
        case 1: {
            if (dismissed) {
                matchResult = 2;
            }
            else {
                matchResult = 0;
                duration = shift.fields[3];
                newEnd = shift.fields[1];
                newStart = shift.fields[0];
                originalStart = shift.fields[2];
            }
            break;
        }
        case 2: {
            matchResult = 1;
            break;
        }
        default:
            matchResult = 2;
    }
    switch (matchResult) {
        case 0:
            return HtmlHelper_createElement("div", ofArray([["role", join(" ", ["status"])], ["className", tw(ofArray([backgroundColor_bgInfo50, border_border, borderColor_borderInfo500, padding_p4, borderRadius_roundedMd, margin_mb4]))], ["children", [HtmlHelper_createElement("p", ofArray([["className", tw(ofArray([fontSize_textSm, textColor_textInfo700]))], ["children", singleton((arg = formatBannerDate(originalStart), (arg_1 = formatBannerDate(newStart), (arg_2 = formatBannerDate(newEnd), toText(printf("Your saved start date (%s) was in the past, so we shifted your dates forward. New range: %s → %s (%d days, same as before)."))(arg)(arg_1)(arg_2)(duration)))))]])), HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([display_flex, gap_gap$002D2, margin_mt2]))], ["children", [HtmlHelper_createElement("button", ofArray([["type", "button"], ["children", singleton("Looks good")], ["onClick", (_arg) => {
                onDismiss();
            }], ["className", tw(ofArray([padding_px3, padding_py1, fontSize_textSm, fontWeight_fontMedium, textColor_textInfo700, hover(backgroundColor_bgInfo100), borderRadius_roundedMd]))]])), HtmlHelper_createElement("button", ofArray([["type", "button"], ["children", singleton("Pick different dates")], ["onClick", (_arg_1) => {
                onPickDifferent();
            }], ["className", tw(ofArray([padding_px3, padding_py1, fontSize_textSm, fontWeight_fontMedium, textColor_textNeutral700, backgroundColor_bgSurfaceElevated, border_border, borderColor_borderNeutral300, borderRadius_roundedMd, hover(backgroundColor_bgNeutral50)]))]]))]]]))]]]));
        case 1:
            return HtmlHelper_createElement("div", ofArray([["role", join(" ", ["alert"])], ["className", tw(ofArray([backgroundColor_bgDanger50, "border-l-4", borderColor_borderDanger500, padding_p4, "rounded-r-md", margin_mb4]))], ["children", [HtmlHelper_createElement("p", ofArray([["className", tw(ofArray([fontSize_textSm, textColor_textDanger800]))], (value_30 = "Your saved dates are in the past and the duration is too long to fit in the next year. Pick new dates.", ["children", singleton(value_30)])]))]]]));
        default:
            return defaultOf();
    }
}

export function ManageChallengeComponent($props) {
    let floor, endKey, arg;
    const paymentFormView = $props.paymentFormView;
    const api = $props.api;
    const dispatch = $props.dispatch;
    const model = $props.model;
    const clock = $props.clock;
    const matchValue = model.CurrentChallenge;
    if (matchValue != null) {
        const challenge = matchValue;
        const isPlanned = challenge.Status === "planned";
        const isPostPublish = ((challenge.Status === "published") ? true : (challenge.Status === "pledged")) ? true : (challenge.Status === "active");
        const isTerminal = ((challenge.Status === "finalizing") ? true : (challenge.Status === "finalized")) ? true : (challenge.Status === "abandoned");
        const isActive = challenge.Status === "active";
        const isGoalFloorEnforced = (challenge.Status === "pledged") ? true : (challenge.Status === "active");
        let isOwner;
        const matchValue_3 = model.CurrentUserId;
        isOwner = ((matchValue_3 == null) ? false : (matchValue_3 === challenge.UserId));
        const lockReason = isPostPublish ? "Cannot be changed after publishing" : (((challenge.Status === "finalizing") ? true : (challenge.Status === "finalized")) ? "Challenge has ended" : ((challenge.Status === "abandoned") ? "Challenge was abandoned" : ""));
        const fieldsLocked = (isPostPublish ? true : isTerminal) ? true : !isOwner;
        const scheduleLockedByStatus = isPostPublish ? true : isTerminal;
        const patternInput = useState(challenge.Title);
        const title = patternInput[0];
        const patternInput_1 = useState(challenge.CoverImage != null);
        const patternInput_2 = useState(defaultArg(challenge.Description, ""));
        const description = patternInput_2[0];
        const patternInput_3 = useState(challenge.Theme);
        const theme = patternInput_3[0];
        const patternInput_4 = useState(challenge.Unit);
        const unit = patternInput_4[0];
        const setUnit = patternInput_4[1];
        const selectedTile = contains(theme, map((t) => t.Value, tiles), {
            Equals: (x, y) => (x === y),
            GetHashCode: (x) => (stringHash(x) | 0),
        }) ? theme : "custom";
        const initialIsCustom = isCustomUnit(challenge.Theme, challenge.Unit);
        const initialCustomText = initialIsCustom ? challenge.Unit : "";
        const patternInput_5 = useState(initialIsCustom ? "__custom__" : challenge.Unit);
        const setSelectedUnitOption = patternInput_5[1];
        const patternInput_6 = useState(initialCustomText);
        const setCustomUnitText = patternInput_6[1];
        const patternInput_7 = useState(challenge.TargetAmount);
        const targetAmount = patternInput_7[0];
        const setTargetAmount = patternInput_7[1];
        const patternInput_8 = useState(date(toUniversalTime(challenge.StartDate)));
        const startDate = patternInput_8[0];
        const setStartDate = patternInput_8[1];
        const patternInput_9 = useState(addDays(startDate, challenge.Duration));
        const setEndDate = patternInput_9[1];
        const endDate = patternInput_9[0];
        const today = date(toUniversalTime(clock.UtcNow()));
        const maxDate = addYears(today, 1);
        const staleShift = useState(applyStaleShift(!scheduleLockedByStatus, today, maxDate, date(toUniversalTime(challenge.StartDate)), challenge.Duration))[0];
        const patternInput_11 = useState(false);
        const setStaleBannerDismissed = patternInput_11[1];
        useEffect(() => {
            switch (staleShift.tag) {
                case 2: {
                    setStartDate(addDays(today, 1));
                    setEndDate(undefined);
                    break;
                }
                case 0: {
                    break;
                }
                default: {
                    setStartDate(staleShift.fields[0]);
                    setEndDate(staleShift.fields[1]);
                }
            }
        }, [challenge.Id]);
        const computedDuration = ((endDate == null) ? challenge.Duration : days(op_Subtraction(date(endDate), date(startDate)))) | 0;
        const origStartTime = toString(toUniversalTime(challenge.StartDate), "HH:mm");
        const patternInput_12 = useState(origStartTime);
        const startTime = patternInput_12[0];
        const persistedReminderTime = map_1(TimeOfDayModule_toStringFormatted, challenge.ReminderTimeOfDay);
        const initialReminderTime = defaultArg(persistedReminderTime, "");
        const patternInput_13 = useState(initialReminderTime);
        const setReminderTime = patternInput_13[1];
        const reminderTime = patternInput_13[0];
        const patternInput_14 = useState(computeOffset(origStartTime, defaultArg(persistedReminderTime, origStartTime)));
        const patternInput_15 = useState(false);
        const patternInput_16 = useState(challenge.Charity);
        const selectedCharity = patternInput_16[0];
        const patternInput_17 = useState("");
        const setCharityQuery = patternInput_17[1];
        const charityQuery = patternInput_17[0];
        const patternInput_18 = useState(empty());
        const setCharityResults = patternInput_18[1];
        const charityResults = patternInput_18[0];
        const patternInput_19 = useState(false);
        const setCharityLoading = patternInput_19[1];
        const titleError = validateTitle(title);
        let targetError;
        const amount = targetAmount;
        const matchValue_4 = challenge.MinAllowedGoal;
        let matchResult, floor_1;
        if (matchValue_4 != null) {
            if ((floor = matchValue_4, isGoalFloorEnforced)) {
                matchResult = 0;
                floor_1 = matchValue_4;
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0: {
                const matchValue_5 = MinAllowedGoal_validate(floor_1, amount);
                targetError = ((matchValue_5.tag === 1) ? matchValue_5.fields[0] : undefined);
                break;
            }
            default: {
                const matchValue_6 = PositiveAmountModule_create(amount);
                targetError = ((matchValue_6.tag === 1) ? "Must be greater than 0" : undefined);
            }
        }
        let rangeError;
        if (endDate != null) {
            const matchValue_7 = validateStartDate(today, startDate);
            if (matchValue_7 == null) {
                const matchValue_8 = ChallengeDurationModule_create(computedDuration);
                rangeError = ((matchValue_8.tag === 1) ? matchValue_8.fields[0] : undefined);
            }
            else {
                rangeError = matchValue_7;
            }
        }
        else {
            rangeError = "Pick a start and end date";
        }
        const patternInput_20 = useAutoSave(title, title !== challenge.Title, titleError != null, (setStatus) => {
            executeSave(setStatus, () => api.renameChallenge(new RenameChallengeRequest(challenge.Id, title)));
        }, autoSaveDelayMs);
        const patternInput_21 = useAutoSave(description, description !== defaultArg(challenge.Description, ""), false, (setStatus_1) => {
            const desc = isNullOrWhiteSpace(description) ? undefined : description;
            executeSave(setStatus_1, () => api.updateDescription(new UpdateDescriptionRequest(challenge.Id, desc)));
        }, autoSaveDelayMs);
        const patternInput_22 = useAutoSave(theme, theme !== challenge.Theme, false, (setStatus_2) => {
            executeSave(setStatus_2, () => api.changeTheme(new ChangeThemeRequest(challenge.Id, theme)));
        }, autoSaveDelayMs);
        const patternInput_23 = useAutoSave(unit, unit !== challenge.Unit, false, (setStatus_3) => {
            executeSave(setStatus_3, () => api.changeUnit(new ChangeUnitRequest(challenge.Id, unit)));
        }, autoSaveDelayMs);
        const patternInput_24 = useAutoSave(toString_1(targetAmount), !equals(targetAmount, challenge.TargetAmount), targetError != null, (setStatus_4) => {
            executeSave(setStatus_4, () => api.changeTargetAmount(new ChangeTargetAmountRequest(challenge.Id, targetAmount)));
        }, autoSaveDelayMs);
        const targetStatus = patternInput_24[0];
        const retryTarget = patternInput_24[1];
        const scheduleChanged = !fieldsLocked && ((!equals_1(startDate, date(toUniversalTime(challenge.StartDate))) ? true : (computedDuration !== challenge.Duration)) ? true : (startTime !== origStartTime));
        const patternInput_25 = useAutoSave((endKey = defaultArg(map_1((e_1) => toString(e_1, "O"), endDate), ""), (arg = toString(startDate, "O"), toText(printf("%s|%s|%s"))(arg)(endKey)(startTime))), scheduleChanged, rangeError != null, (setStatus_5) => {
            const browserTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            let fullStartDateTime;
            const matchValue_9 = TimeOfDayModule_parseFormatted(startTime);
            if (matchValue_9.tag === 1) {
                fullStartDateTime = date(startDate);
            }
            else {
                const tod = matchValue_9.fields[0];
                fullStartDateTime = addMinutes(addHours(date(startDate), TimeOfDayModule_hour(tod)), TimeOfDayModule_minute(tod));
            }
            executeSave(setStatus_5, () => singleton_1.Delay(() => singleton_1.Bind(api.changeDuration(new ChangeDurationRequest(challenge.Id, computedDuration)), (_arg) => {
                const durResult = _arg;
                return (durResult.tag === 0) ? singleton_1.ReturnFrom(api.rescheduleChallenge(new RescheduleChallengeRequest(challenge.Id, fullStartDateTime, browserTimezone))) : singleton_1.Return(new FSharpResult$2(1, [durResult.fields[0]]));
            })));
        }, autoSaveDelayMs);
        let reminderTimeParseError;
        if (isNullOrWhiteSpace(reminderTime)) {
            reminderTimeParseError = undefined;
        }
        else {
            const matchValue_10 = TimeOfDayModule_parseFormatted(reminderTime);
            reminderTimeParseError = ((matchValue_10.tag === 1) ? matchValue_10.fields[0] : undefined);
        }
        const patternInput_26 = useAutoSave(reminderTime, reminderTime !== initialReminderTime, reminderTimeParseError != null, (setStatus_6) => {
            const reminderTimeOfDay = isNullOrWhiteSpace(reminderTime) ? (new FSharpResult$2(0, [undefined])) : Result_Map((Value) => Value, TimeOfDayModule_parseFormatted(reminderTime));
            executeSave(setStatus_6, () => ((reminderTimeOfDay.tag === 1) ? singleton_1.Delay(() => singleton_1.Return(new FSharpResult$2(1, [ApiErrorModule_ofString(reminderTimeOfDay.fields[0])]))) : api.changeReminderTime(new ChangeReminderTimeRequest(challenge.Id, reminderTimeOfDay.fields[0]))));
        }, autoSaveDelayMs);
        useEffect(() => {
            if (charityQuery.length >= 2) {
                setCharityLoading(true);
                startImmediate(singleton_1.Delay(() => singleton_1.Combine(singleton_1.TryWith(singleton_1.Delay(() => singleton_1.Bind(searchEveryOrg(charityQuery), (_arg_1) => {
                    setCharityResults(_arg_1);
                    return singleton_1.Zero();
                })), (_arg_2) => {
                    setCharityResults(empty());
                    return singleton_1.Zero();
                }), singleton_1.Delay(() => {
                    setCharityLoading(false);
                    return singleton_1.Zero();
                }))));
            }
            else {
                setCharityResults(empty());
                setCharityLoading(false);
            }
        }, [charityQuery]);
        const patternInput_27 = useAutoSave(selectedCharity.Slug, selectedCharity.Slug !== challenge.Charity.Slug, false, (setStatus_7) => {
            executeSave(setStatus_7, () => api.changeCharity(new ChangeCharityRequest(challenge.Id, selectedCharity)));
        }, autoSaveDelayMs);
        const showAbandon = isOwner && (isPlanned ? true : isPostPublish);
        let authToken;
        const matchValue_11 = model.Auth;
        authToken = ((matchValue_11.tag === 1) ? matchValue_11.fields[0] : undefined);
        const completenessRow = CompletenessChecklist_derive(title, description, theme, targetAmount, computedDuration, targetError, selectedCharity.Slug, patternInput_1[0]);
        const heroInputs = new Inputs(clock, challenge, model, dispatch, paymentFormView, targetAmount, targetError, setTargetAmount, fieldStatusIndicator(targetStatus, retryTarget), completenessRow);
        const lockedSidebarMode = new Mode(new LockedProps(challenge));
        return HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([maxWidth_w7Xl, margin_mxAuto, padding_px4, sm(padding_px6), lg(padding_px8), padding_py8]))], ["children", [HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([display_flex, alignItems_itemsCenter, gap_gap3, margin_mb2]))], ["children", [HtmlHelper_createElement("h1", ofArray([["className", tw(ofArray([fontSize_text3Xl, fontWeight_fontBold, textColor_textNeutral900]))], ["children", singleton("Manage Challenge")]])), fromString(challenge.Status)]]])), HtmlHelper_createElement("p", ofArray([["className", tw(ofArray([textColor_textNeutral600, margin_mb8]))], ["children", singleton(isTerminal ? toText(printf("This challenge is %s."))(challenge.Status) : (isPostPublish ? "Some fields are locked after publishing." : "Update your challenge details below."))]])), HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([display_flex, flexDirection_flexCol, lg("grid"), lg("grid-cols-[1fr_320px]"), lg("gap-8")]))], ["children", [HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([display_flex, flexDirection_flexCol, "gap-8"]))], ["children", toList(delay(() => append(singleton_2(HtmlHelper_createElement("div", ofArray([["className", isActive ? tw(ofArray(["order-last", lg("order-none")])) : ""], ["children", [HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([display_flex, flexDirection_flexCol, gap_gap4]))], ["children", [createElement(CoverImageSlot, {
            challenge: challenge,
            api: api,
            authToken: unwrap(authToken),
            isOwner: isOwner,
            onCoverChanged: patternInput_1[1],
        }), view_1(heroInputs)]]]))]]]))), delay(() => {
            let matchValue_12;
            return append(isOwner ? ((matchValue_12 = model.FeeShareStatus, (matchValue_12 == null) ? (model.LoadingFeeShareStatus ? singleton_2(skeleton()) : singleton_2(defaultOf())) : singleton_2(view_2(derive(matchValue_12, challenge.Status, challenge.Id, challenge.Charity.Name, progressPct(challenge.TotalUnitsCompleted, challenge.TargetAmount), model.FeeSharePollAttempts))))) : singleton_2(defaultOf()), delay(() => (isOwner ? singleton_2(HtmlHelper_createElement("div", ofArray([["id", "daily-log"], ["data-challenge-id", challenge.Id], ["aria-busy", model.LoadingDailyLogs], ["children", [createElement(DailyLogSection, {
                clock: clock,
                challenge: challenge,
                model: model,
                dispatch: dispatch,
            })]]]))) : singleton_2(defaultOf()))));
        }))))]])), HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([lg("sticky"), lg("top-8"), lg("self-start")]))], ["children", toList(delay(() => {
            let arg_4;
            return append(fieldsLocked ? singleton_2(HtmlHelper_createElement("div", ofArray([["className", tw(singleton(space_spaceY4))], ["children", [view_3(lockedSidebarMode)]]]))) : singleton_2(HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([backgroundColor_bgSurface, borderRadius_roundedLg, boxShadow_shadow, padding_p6, space_spaceY6]))], ["children", [HtmlHelper_createElement("h3", ofArray([["className", tw(ofArray([fontSize_textLg, fontWeight_fontSemibold, textColor_textNeutral900]))], ["children", singleton("Challenge Details")]])), formField("Challenge Title", "title", titleError, undefined, true, fieldStatusIndicator(patternInput_20[0], patternInput_20[1]), (ariaProps) => HtmlHelper_createElement("input", append_1(ofArray([["id", "title"], ["type", "text"], ["className", inputClass(titleError != null)], ["value", title], ["onChange", (e_4) => {
                const target = e_4.target;
                patternInput[1](target.value);
            }]]), ariaProps))), formField("Description (Optional)", "description", undefined, (arg_4 = (description.length | 0), toText(printf("%d/500 characters"))(arg_4)), false, fieldStatusIndicator(patternInput_21[0], patternInput_21[1]), (ariaProps_1) => HtmlHelper_createElement("textarea", append_1(ofArray([["id", "description"], ["rows", 4], ["className", inputClass(false)], ["placeholder", "Tell supporters about your challenge and why this cause matters to you..."], ["value", description], ["onChange", (e_5) => {
                const target_1 = e_5.target;
                patternInput_2[1](target_1.value);
            }]]), ariaProps_1))), HtmlHelper_createElement("div", singleton(["children", [HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([display_flex, alignItems_itemsCenter, justifyContent_justifyBetween]))], ["children", [HtmlHelper_createElement("div", ofArray([["className", labelClass], ["children", singleton("Activity Type")]])), fieldStatusIndicator(patternInput_22[0], patternInput_22[1])]]])), HtmlHelper_createElement("div", ofArray([["className", margin_mt2], ["children", [view_4(selectedTile, (newTheme) => {
                if ((newTheme !== "custom") ? true : (selectedTile !== "custom")) {
                    patternInput_3[1](newTheme);
                    const newUnit = defaultUnitForActivity(newTheme);
                    setUnit(newUnit);
                    setSelectedUnitOption(newUnit);
                    setCustomUnitText(isCustomUnit(newTheme, newUnit) ? newUnit : "");
                }
            })]]]))]])), view_5(theme, patternInput_5[0], patternInput_6[0], (newOption) => {
                setSelectedUnitOption(newOption);
                if (newOption !== "__custom__") {
                    setUnit(newOption);
                    setCustomUnitText("");
                }
            }, (newText) => {
                setCustomUnitText(newText);
                if (!isNullOrWhiteSpace(newText)) {
                    setUnit(newText);
                }
            }, fieldsLocked, lockReason, undefined, fieldStatusIndicator(patternInput_23[0], patternInput_23[1])), formField("Target Amount", "targetAmount", targetError, undefined, true, fieldStatusIndicator(targetStatus, retryTarget), (ariaProps_2) => HtmlHelper_createElement("input", append_1(ofArray([["id", "targetAmount"], ["type", "number"], ["className", inputClass(targetError != null)], ["value", equals(targetAmount, fromParts(0, 0, 0, false, 0)) ? "" : toString_1(targetAmount)], ["onChange", (e_6) => {
                const target_2 = e_6.target;
                let matchValue_13;
                let outArg = new Decimal("0");
                matchValue_13 = [tryParse(target_2.value, new FSharpRef(() => outArg, (v) => {
                    outArg = v;
                })), outArg];
                if (matchValue_13[0]) {
                    setTargetAmount(matchValue_13[1]);
                }
                else if (isNullOrWhiteSpace(target_2.value)) {
                    setTargetAmount(fromParts(0, 0, 0, false, 0));
                }
            }]]), ariaProps_2))), HtmlHelper_createElement("div", singleton(["children", toList(delay(() => append(singleton_2(HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([display_flex, justifyContent_justifyBetween, alignItems_itemsCenter]))], ["children", [HtmlHelper_createElement("div", empty()), fieldStatusIndicator(patternInput_25[0], patternInput_25[1])]]]))), delay(() => append(singleton_2(renderStaleShiftBanner(staleShift, patternInput_11[0], () => {
                setStaleBannerDismissed(true);
            }, () => {
                setEndDate(undefined);
                setStaleBannerDismissed(true);
            })), delay(() => append(singleton_2(render(new Props(new SelectedRange(startDate, endDate), (range) => {
                const patternInput_28 = applyEditRangeChange(range, startDate, endDate);
                setStartDate(patternInput_28[0]);
                setEndDate(patternInput_28[1]);
            }, (_arg_3) => {
            }, today, maxDate, ChallengeDurationModule_minDays, ChallengeDurationModule_maxDays, "Schedule", true))), delay(() => {
                let matchValue_14;
                return append((matchValue_14 = rangeError, (matchValue_14 == null) ? singleton_2(defaultOf()) : singleton_2(inlineError(matchValue_14))), delay(() => singleton_2(HtmlHelper_createElement("div", ofArray([["className", margin_mt4], ["children", toList(delay(() => append(singleton_2(HtmlHelper_createElement("label", ofArray([["htmlFor", "startTime"], ["className", labelClass], ["children", ["Start time", HtmlHelper_createElement("span", ofArray([["aria-hidden", "true"], ["className", tw(ofArray([textColor_textDanger600, margin_ml1]))], ["children", singleton("*")]]))]]]))), delay(() => append(singleton_2(HtmlHelper_createElement("input", ofArray([["id", "startTime"], ["type", "time"], ["step", "900"], ["className", inputClass(false)], ["value", startTime], ["aria-label", "Start time"], ["onChange", (e_7) => {
                    const target_3 = e_7.target;
                    const newTime = target_3.value;
                    patternInput_12[1](newTime);
                    if (!patternInput_15[0]) {
                        setReminderTime(applyOffset(patternInput_14[0], newTime));
                    }
                }]]))), delay(() => {
                    let arg_5;
                    if ((rangeError == null) && (endDate != null)) {
                        const browserTimezone_1 = Intl.DateTimeFormat().resolvedOptions().timeZone;
                        return singleton_2(HtmlHelper_createElement("p", ofArray([["className", tw(ofArray([margin_mt1, fontSize_textSm, textColor_textNeutral600]))], ["children", singleton((arg_5 = toString(startDate, "MMMM d"), toText(printf("Your challenge starts %s at %s (%s)"))(arg_5)(startTime)(browserTimezone_1)))]])));
                    }
                    else {
                        return singleton_2(defaultOf());
                    }
                }))))))]])))));
            }))))))))])), formField("Daily Log Reminder Time", "reminderTime", reminderTimeParseError, "When you\'ll get daily log reminders for this challenge", false, fieldStatusIndicator(patternInput_26[0], patternInput_26[1]), (ariaProps_3) => HtmlHelper_createElement("input", append_1(ofArray([["id", "reminderTime"], ["type", "time"], ["step", "900"], ["className", inputClass(false)], ["value", reminderTime], ["onChange", (e_8) => {
                const target_4 = e_8.target;
                setReminderTime(target_4.value);
                patternInput_15[1](true);
            }]]), ariaProps_3))), HtmlHelper_createElement("div", singleton(["children", toList(delay(() => append(singleton_2(HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([display_flex, justifyContent_justifyBetween, alignItems_itemsCenter]))], ["children", [HtmlHelper_createElement("label", ofArray([["htmlFor", "charity-search"], ["className", labelClass], ["children", singleton("Charity")]])), fieldStatusIndicator(patternInput_27[0], patternInput_27[1])]]]))), delay(() => (isNullOrEmpty(everyOrgApiKey) ? singleton_2(HtmlHelper_createElement("p", ofArray([["className", tw(ofArray([margin_mt1, fontSize_textSm, textColor_textNeutral500]))], ["children", singleton("Charity search unavailable")]]))) : singleton_2(HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([margin_mt1, position_relative]))], ["children", toList(delay(() => append(singleton_2(HtmlHelper_createElement("input", ofArray([["id", "charity-search"], ["data-testid", "charity-search"], ["type", "text"], ["className", inputClass(false)], ["placeholder", "Search for a charity..."], ["value", charityQuery], ["onChange", (e_9) => {
                const target_5 = e_9.target;
                setCharityQuery(target_5.value);
            }]]))), delay(() => append(patternInput_19[0] ? singleton_2(HtmlHelper_createElement("p", ofArray([["className", tw(ofArray([margin_mt1, fontSize_textSm, textColor_textNeutral500]))], ["children", singleton("Searching...")]]))) : ((length(charityResults) > 0) ? singleton_2(HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([position_absolute, width_wFull, backgroundColor_bgSurfaceElevated, border_border, borderColor_borderNeutral200, borderRadius_roundedMd, boxShadow_shadowLg, zIndex_z10, margin_mt1]))], ["children", map((charity) => HtmlHelper_createElement("div", ofArray([["data-testid", "charity-result"], ["className", tw(ofArray([padding_px4, padding_py3, cursor_cursorPointer, hover(backgroundColor_bgNeutral50)]))], ["onClick", (_arg_4) => {
                patternInput_16[1](charity);
                setCharityQuery("");
                setCharityResults(empty());
            }], ["children", [HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([display_flex, alignItems_itemsCenter, gap_gap$002D2]))], ["children", toList(delay(() => {
                let matchValue_15;
                return append((matchValue_15 = charity.LogoUrl, (matchValue_15 == null) ? singleton_2(defaultOf()) : singleton_2(HtmlHelper_createElement("img", ofArray([["src", matchValue_15], ["alt", charity.Name], ["className", tw(ofArray([width_w6, height_h6, borderRadius_roundedFull]))]])))), delay(() => singleton_2(HtmlHelper_createElement("span", ofArray([["className", tw(ofArray([fontSize_textSm, textColor_textNeutral900]))], ["children", singleton(charity.Name)]])))));
            }))]]))]]])), charityResults)]]))) : singleton_2(defaultOf())), delay(() => singleton_2(HtmlHelper_createElement("div", ofArray([["data-testid", "charity-selected"], ["className", tw(ofArray([margin_mt2, padding_px3, padding_py2, backgroundColor_bgSuccess50, borderRadius_roundedMd, display_flex, alignItems_itemsCenter, gap_gap$002D2]))], ["children", toList(delay(() => {
                let matchValue_16;
                return append((matchValue_16 = selectedCharity.LogoUrl, (matchValue_16 == null) ? singleton_2(defaultOf()) : singleton_2(HtmlHelper_createElement("img", ofArray([["src", matchValue_16], ["alt", selectedCharity.Name], ["className", tw(ofArray([width_w6, height_h6, borderRadius_roundedFull]))]])))), delay(() => singleton_2(HtmlHelper_createElement("span", ofArray([["className", tw(ofArray([fontSize_textSm, fontWeight_fontMedium, textColor_textSuccess800]))], ["children", singleton(selectedCharity.Name)]])))));
            }))]])))))))))]]))))))))]))]]]))), delay(() => append((isOwner && !isPlanned) ? singleton_2(HtmlHelper_createElement("div", ofArray([["className", tw(singleton(margin_mt6))], ["children", toList(delay(() => (pledgeStatsIsClickable(challenge.PledgeCount) ? singleton_2(HtmlHelper_createElement("a", ofArray([["data-testid", "pledge-stats-link"], ["className", tw(ofArray([display_inlineFlex, alignItems_itemsCenter, gap_gap$002D2, fontSize_textSm, fontWeight_fontMedium, textColor_textPrimary600, hover(textColor_textPrimary700), cursor_cursorPointer]))], ["href", toText(printf("/challenges/%s/pledges"))(challenge.Id)], ["children", [createElement(icon, {
                name: new IconName(43, []),
                size: new IconSize(0, []),
                weight: new IconWeight(0, []),
            }), pledgeStatsText(challenge.PledgeCount, challenge.TotalPledged), createElement(icon, {
                name: new IconName(42, []),
                size: new IconSize(0, []),
                weight: new IconWeight(0, []),
            }), createElement(icon, {
                name: new IconName(38, []),
                size: new IconSize(0, []),
                weight: new IconWeight(0, []),
            })]], ["onClick", (e_10) => {
                e_10.preventDefault();
                dispatch(new ClientTypes_Msg(37, [new ClientTypes_Route(11, [challenge.Id])]));
            }]]))) : singleton_2(HtmlHelper_createElement("p", ofArray([["data-testid", "pledge-stats-text"], ["className", tw(ofArray([display_inlineFlex, alignItems_itemsCenter, gap_gap$002D2, fontSize_textSm, textColor_textNeutral500]))], ["children", [createElement(icon, {
                name: new IconName(43, []),
                size: new IconSize(0, []),
                weight: new IconWeight(0, []),
            }), pledgeStatsText(challenge.PledgeCount, challenge.TotalPledged), createElement(icon, {
                name: new IconName(42, []),
                size: new IconSize(0, []),
                weight: new IconWeight(0, []),
            })]]]))))))]]))) : singleton_2(defaultOf()), delay(() => (showAbandon ? singleton_2(view_6(api, challenge.Id, dispatch)) : singleton_2(defaultOf()))))));
        }))]]))]]]))]]]));
    }
    else if (model.LoadingChallenge) {
        return HtmlHelper_createElement("div", ofArray([["role", join(" ", ["status"])], ["aria-label", "Loading challenge"], ["aria-busy", "true"], ["className", tw(singleton(space_spaceY4))], ["children", [skeletonHeading(50), skeletonLine(75), skeletonLine(33), HtmlHelper_createElement("div", singleton(["className", tw(ofArray(["aspect-[1200/630]", width_wFull, borderRadius_roundedLg, backgroundColor_bgNeutral200, animation_animatePulse]))])), HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([backgroundColor_bgSurface, borderRadius_roundedLg, boxShadow_shadow, padding_p6, margin_mt4, space_spaceY4]))], ["children", [skeletonLine(100), skeletonLine(75), skeletonLine(50)]]]))]]]));
    }
    else {
        let retryDispatch;
        const matchValue_1 = model.CurrentRoute;
        retryDispatch = ((matchValue_1.tag === 2) ? (() => {
            dispatch(new ClientTypes_Msg(38, [matchValue_1.fields[0]]));
        }) : undefined);
        const matchValue_2 = model.ChallengeLoadError;
        let matchResult_1, err_1;
        if (matchValue_2 != null) {
            if (!ApiErrorModule_isNotFound(matchValue_2)) {
                matchResult_1 = 0;
                err_1 = matchValue_2;
            }
            else {
                matchResult_1 = 1;
            }
        }
        else {
            matchResult_1 = 1;
        }
        switch (matchResult_1) {
            case 0:
                return PageError_render_Z70A9CE70(new PageErrorKind(2, ["Something went wrong loading this challenge. Please try again."]), retryDispatch, undefined, "Browse Challenges", "/challenges");
            default:
                return PageError_render_Z70A9CE70(new PageErrorKind(0, ["The challenge you\'re looking for doesn\'t exist or has been moved."]), undefined, new IconName(55, []), "Browse Challenges", "/challenges");
        }
    }
}

/**
 * Challenge management content without a back link.
 * Includes its own max-width layout container.
 * Used both by the standalone challenge route and the dashboard single-challenge view.
 */
export function viewContent(clock, model, dispatch, api, paymentFormView) {
    return createElement(ManageChallengeComponent, {
        clock: clock,
        model: model,
        dispatch: dispatch,
        api: api,
        paymentFormView: paymentFormView,
    });
}

export function view(clock, model, dispatch, api, paymentFormView) {
    return HtmlHelper_createElement("div", singleton(["children", [HtmlHelper_createElement("button", ofArray([["className", tw(ofArray([display_hidden, md(display_block), margin_mb4, textColor_textSecondary600, hover(textColor_textSecondary800)]))], ["children", singleton("← Back to dashboard")], ["onClick", (_arg) => {
        dispatch(new ClientTypes_Msg(37, [new ClientTypes_Route(0, [])]));
    }]])), viewContent(clock, model, dispatch, api, paymentFormView)]]));
}

//# sourceMappingURL=ChallengeEditView.js.map
